// extracted by mini-css-extract-plugin
export default {"root":"DuplicatesPreview__root--3wC2j","label":"DuplicatesPreview__label--1rL0g","img":"DuplicatesPreview__img--3nwur"};